import {FileManagerService} from "../services";

export default (oldPath, newPath) => {
    return new Promise((resolve, reject) => {
        FileManagerService.renameClientFile(oldPath, newPath)
            .then(response => {
                resolve(response)
            }).catch(err => {
            reject(err.response)
        })
    })

}